import React from 'react'
import TextScroll from '../Components/TextScroll'

const InfoBanner = () => {
    return (
      <TextScroll Text=" — updates coming soon — updates coming soon — updates coming soon — " />
    )
}
  


export default InfoBanner